export const menuItems = [
    {
        id: 1,
        label: 'module.home',
        icon: 'mdi mdi-home',
        link: '/',
    },
    {
        id: 20,
        label: 'module.sales',
        icon: 'mdi mdi-cart',
        subItems: [
            { id: 21, label: 'module.salesDoc', link: '/sales-docs', permission: 'Read Sales Document' },
            { id: 22, label: 'module.delivery', link: '/deliveries', permission: 'Read Delivery' },
            { id: 23, label: 'module.payment', link: '/payments', permission: 'Read Payment' },
            { id: 24, label: 'module.aging', link: '/aging', permission: 'Read Aging' },
        ],
    },
    {
        id: 30,
        label: 'module.inventory',
        icon: 'mdi mdi-package-variant',
        subItems: [
            { id: 31, label: 'module.product', link: '/products', permission: 'Read Product' },
            { id: 32, label: 'module.itemPrice', link: '/item-prices', permission: 'Read Item Price', capability: 'price_lists' },
            { id: 33, label: 'module.stockBalance', link: '/stock-balances', permission: 'Read Stock Balance', capability: 'stock_operations' },
            { id: 34, label: 'module.stockOperation', link: '/stock-operations', permission: 'Read Stock Operation', capability: 'stock_operations' },
        ],
    },
    {
        id: 40,
        label: 'module.customer',
        icon: 'mdi mdi-account-multiple',
        subItems: [
            { id: 41, label: 'module.client', link: '/clients', permission: 'Read Client' },
            { id: 56, label: 'clientGroup.title', link: '/client-groups', permission: 'Read Client Group' },
            { id: 42, label: 'module.store', link: '/stores', permission: 'Read Store' },
        ],
    },
    {
        id: 60,
        label: 'module.crm',
        icon: 'mdi mdi-account-heart',
        subItems: [
            { id: 61, label: 'module.lead', link: '/leads', permission: 'Read CRM' },
            { id: 62, label: 'module.deal', link: '/opportunities', permission: 'Read CRM' },
            { id: 63, label: 'module.activity', link: '/activities', permission: 'Read CRM' },
            { id: 64, label: 'module.contact', link: '/contacts', permission: 'Read CRM' },
            { id: 65, label: 'module.leadForm', link: '/lead-forms', permission: 'Read CRM' },
        ],
    },
    {
        id: 50,
        label: 'module.management',
        icon: 'mdi mdi-chart-line',
        subItems: [
            { id: 51, label: 'module.salesTarget', link: '/sales-targets', permission: 'Read Sales Target' },
            // Commission module hidden from UI (pages/routes still exist, just not surfaced).
            // { id: 52, label: 'module.commissionRate', link: '/commission-rates', permission: 'Read Commission' },
            // { id: 53, label: 'module.commissionRecord', link: '/commission-records', permission: 'Read Commission' },
            { id: 54, label: 'module.approval', link: '/approvals', permission: 'Read Approval' },
            { id: 55, label: 'module.report', link: '/reports', permission: 'Read Report' },
            // Cash the signed-in agent is holding. No permission — it is their own.
            { id: 56, label: 'module.myWallet', link: '/my-wallet' },
        ],
    },
    {
        id: 10,
        label: 'module.admin',
        icon: 'mdi mdi-shield-account',
        subItems: [
            { id: 11, label: 'module.user', link: '/users', permission: 'Read User' },
            // Sales agents: mirrored from AutoCount / SQL Account, or kept here for Xero / QuickBooks.
            { id: 18, label: 'module.agent', link: '/agents', permission: 'Read Agent' },
            // Mobile-app signup accounts (own auth guard) — not the CRM's customers.
            { id: 16, label: 'module.appUser', link: '/customers', permission: 'Read Customer' },
            { id: 12, label: 'module.role', link: '/roles', permission: 'Read Role' },
            { id: 13, label: 'module.configuration', link: '/configurations', permission: 'Read Configuration' },
            // Xero / QuickBooks OAuth link; AutoCount / SQL Account only see a note here.
            { id: 19, label: 'module.accountingConnection', link: '/accounting-connection', permission: 'Update Configuration' },
            { id: 17, label: 'module.companyProfile', link: '/company-profiles', permission: 'Read Company Profile' },
            { id: 20, label: 'module.paymentMethod', link: '/payment-methods', permission: 'Read Payment Method' },
            { id: 21, label: 'module.wallet', link: '/wallets', permission: 'Read Wallet' },
            { id: 14, label: 'module.checkIn', link: '/user-metadatas', permission: 'Read Check In' },
            { id: 15, label: 'module.communicationLog', link: '/communication-logs', permission: 'Read Communication Log' },
        ],
    },
]
